module.exports = __webpack_public_path__ + "img/logo.25764bd2.png";